import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Pipe({
  name: 'sanitizeNumberLink',
})
export class SanitizeNumberLinkPipe implements PipeTransform {
  constructor(private readonly sanitizer: DomSanitizer) {}

  transform(value: any): SafeUrl {
    const phoneNumber = value?.changingThisBreaksApplicationSecurity || value;

    return this.sanitizer.bypassSecurityTrustUrl(`${environment.CALL_PREFIX}${phoneNumber}?dialAction=autoCall`);
  }
}
